import axios from "axios";
import { insertFriend } from "./FriendAction";
import { insertParticipant } from "./ParticipantAction";
import Janus from "janus-gateway";
import adapter from "webrtc-adapter";

const REACT_APP_MICRO_CHAT_URL = process.env.REACT_APP_MICRO_CHAT_URL;
const REACT_APP_JANUS_SERVER = process.env.REACT_APP_JANUS_SERVER;

const radio_id = localStorage.getItem("radio_id");

function createThread(myroom) {
  var janus = null;
  var textroom = null;

  Janus.init({
    debug: false,
    dependencies: Janus.useDefaultDependencies({ adapter: adapter }),
    callback: () => {
      janus = new Janus({
        server: REACT_APP_JANUS_SERVER,
        success: () => {
          janus.attach({
            plugin: "janus.plugin.textroom",
            success: function (pluginHandle) {
              textroom = pluginHandle;
              // Setup the DataChannel
              let body = { request: "setup" };
              pluginHandle.send({ message: body });
            },
            onmessage: function (msg, jsep) {
              if (jsep) {
                // Answer
                textroom.createAnswer({
                  jsep: jsep,
                  // We only use datachannels
                  tracks: [{ type: "data" }],
                  success: function (jsep) {
                    let body = { request: "ack" };
                    textroom.send({ message: body, jsep: jsep });
                  },
                  error: function (error) {},
                });
              }
            },
            ondataopen: function (label, protocol) {
              let transaction = Janus.randomString(12);

              let create = {
                textroom: "create",
                transaction: transaction,
                room: myroom,
              };
              textroom.data({
                text: JSON.stringify(create),
                error: function (reason) {},
                success: function (reason) {},
              });
            },
          });
        },
      });
    },
  });
}

export const getThreadById = (id) => (dispatch) => {
  axios.get(`${REACT_APP_MICRO_CHAT_URL}/threads/${id}`).then((response) => {
    dispatch({
      type: "GET_THREAD_BY_ID",
      payload: response.data.data,
      totalPages: response.data.data.length,
    });
  });
};
export const getThreadsByEpisodeId = (id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/threads/episode/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_THREADS_BY_EPISODE_ID",
        payload: response.data.data,
        totalPages: response.data.data.length,
      });
    });
};
export const getThreadsByUserId = (type, id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/threads/thread_user/${type}/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_THREADS_BY_USER_ID",
        payload: response.data.data,
        totalPages: response.data.data.length,
      });
    });
};

export const getThreadsByTypeId = (type) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/threads/type/${type}/${radio_id}`)
    .then((response) => {
      dispatch({
        type: "GET_THREADS_BY_TYPE_ID",
        payload: response.data.data,
        totalPages: response.data.data.length,
      });
    });
};

export const getSearchThreadsByUserId = (type, id, search) => (dispatch) => {
  axios
    .get(
      `${REACT_APP_MICRO_CHAT_URL}/threads/user/_search/${type}/${id}?search=${search}`
    )
    .then((response) => {
      dispatch({
        type: "GET_SEARCH_THREADS_BY_USER_ID",
        payload: response.data.data,
        totalPages: response.data.data.length,
      });
    });
};
export const getSearchThreadsByTypeId = (type, search) => (dispatch) => {
  axios
    .get(
      `${REACT_APP_MICRO_CHAT_URL}/threads/type/_search/${type}/${radio_id}?search=${search}`
    )
    .then((response) => {
      dispatch({
        type: "GET_SEARCH_THREADS_BY_TYPE_ID",
        payload: response.data.data,
        totalPages: response.data.data.length,
      });
    });
};
export const getThreadsByRadioId = (id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/threads/radio/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_THREADS_BY_RADIO_ID",
        payload: response.data.data,
        totalPages: response.data.data.length,
      });
    });
};
export const getOpenedThreadByRadioId = (id) => (dispatch) => {
  axios
    .get(`${REACT_APP_MICRO_CHAT_URL}/threads/lockout/${id}`)
    .then((response) => {
      dispatch({
        type: "GET_OPENED_THREADS_BY_RADIO_ID",
        payload: response.data.data,
      });
    });
};
export const openClosethread = (id, data) => (dispatch) => {
  axios
    .patch(`${REACT_APP_MICRO_CHAT_URL}/threads/open_close_thread/${id}`, data)
    .then(() => {
      dispatch({
        type: "OPEN_CLOSE_THREAD_SUCCESS",
      });
    })
    .catch((err) => {
      dispatch({
        type: "OPEN_CLOSE_THREAD_FAILED",
        payload: err.response,
      });
    });
};
export const insertThread = (data) => (dispatch) => {
  axios
    .post(`${REACT_APP_MICRO_CHAT_URL}/threads`, data)
    .then((response) => {
      dispatch({
        type: "INSERT_THREAD_SUCCESS",
        payload: response.data.data,
      });
      createThread(response.data.data.id);
    })
    .catch((err) => {
      console.log("err", err);
      dispatch({
        type: "INSERT_THREAD_FAILED",
        payload: err.response.data.message,
      });
    });
};
export const insertPrivateThread =
  (data, user_x, user_y, func) => (dispatch) => {
    axios
      .post(`${REACT_APP_MICRO_CHAT_URL}/threads`, data)
      .then(async (response) => {
        dispatch({
          type: "INSERT_THREAD_SUCCESS",
          payload: response.data.data,
        });
        await dispatch(
          insertParticipant({
            is_admin: true,
            is_blocked: false,
            user: user_x,
            thread: response.data.data.id,
          })
        );
        await dispatch(
          insertParticipant({
            is_admin: false,
            is_blocked: false,
            user: user_y,
            thread: response.data.data.id,
          })
        );
        await dispatch(
          insertFriend({
            sender: user_x,
            receiver: user_y,
          })
        );
        createThread(response.data.data.id);
        func();
      })
      .catch((err) => {
        dispatch({
          type: "INSERT_THREAD_FAILED",
          payload: err.response.data.message,
        });
      });
  };
export const insertPrivateGroupThread =
  (data, user_x, participants, func) => (dispatch) => {
    axios
      .post(`${REACT_APP_MICRO_CHAT_URL}/threads`, data)
      .then((response) => {
        dispatch({
          type: "INSERT_THREAD_SUCCESS",
          payload: response.data.data,
        });
        dispatch(
          insertParticipant({
            is_admin: true,
            is_blocked: false,
            user: user_x,
            thread: response.data.data.id,
          })
        );
        for (let index = 0; index < participants.length; index++) {
          const element = participants[index];
          dispatch(
            insertParticipant({
              is_admin: false,
              is_blocked: false,
              user: element,
              thread: response.data.data.id,
            })
          );
        }
        dispatch(getThreadsByUserId(1, user_x));
        createThread(response.data.data.id);
        func();
      })
      .catch((err) => {
        dispatch({
          type: "INSERT_THREAD_FAILED",
          payload: err.response.data.message,
        });
      });
  };
export const editThread = (id, data) => (dispatch) => {
  axios
    .put(`${REACT_APP_MICRO_CHAT_URL}/threads/${id}`, data)
    .then(() => {
      dispatch({
        type: "EDIT_THREAD_SUCCESS",
      });
    })
    .catch((err) => {
      dispatch({
        type: "EDIT_THREAD_FAILED",
        payload: err.response,
      });
    });
};
export const removeThread = (id) => (dispatch) => {
  axios
    .delete(`${REACT_APP_MICRO_CHAT_URL}/threads/${id}`)
    .then(() => {
      dispatch({
        type: "REMOVE_THREAD_SUCCESS",
      });
    })
    .catch((err) => {
      dispatch({
        type: "REMOVE_THREAD_FAILED",
        payload: err.response,
      });
    });
};
